import { defineMessages } from 'react-intl'

export const lang = defineMessages({
    title: {
        id: 'receive.title',
        defaultMessage: 'Receive {currency}',
    },
    crypto: {
        id: 'receive.widget.crypto',
        defaultMessage: 'Crypto',
    },
    fiat: {
        id: 'receive.widget.fiat',
        defaultMessage: 'Fiat',
    },
})
